module.exports = __webpack_public_path__ + "img/failure icon.d70b0585.png";